(() => {
  "use strict";
  if (window.__ohCelebrityAnalyticsBound) return;
  window.__ohCelebrityAnalyticsBound = true;

  const consentAllowed = () => {
    if (navigator.globalPrivacyControl === true) return false;
    const privacy = window.Shopify?.customerPrivacy;
    try {
      return typeof privacy?.analyticsProcessingAllowed === "function"
        && typeof privacy?.userCanBeTracked === "function"
        && privacy.analyticsProcessingAllowed() === true
        && privacy.userCanBeTracked() === true;
    } catch (_) {
      return false;
    }
  };

  const sessionId = () => {
    try {
      let value = sessionStorage.getItem("ohs_session") || sessionStorage.getItem("ohc_session") || "";
      if (!value) {
        const random = crypto.getRandomValues(new Uint32Array(2)).join("-");
        value = `${Date.now()}-${random}`;
        sessionStorage.setItem("ohc_session", value);
      }
      return value.slice(0, 120);
    } catch (_) {
      return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    }
  };

  const eventEndpoint = (target) => {
    const host = target?.closest?.("[data-endpoint]") || document.querySelector("[data-endpoint]");
    const raw = String(host?.dataset.endpoint || "").replace(/\/+$/, "");
    if (!raw) return "";
    try {
      const url = new URL(raw, location.origin);
      const basePath = url.pathname.replace(/\/(?:oh-search\/)?v1\/celebrities(?:\/.*)?$/, "").replace(/\/+$/, "");
      return `${url.origin}${basePath}/v1/events`;
    } catch (_) {
      return "";
    }
  };

  const send = (sourceEvent, eventType, detail) => {
    if (!consentAllowed()) return;
    const endpoint = eventEndpoint(sourceEvent.target);
    if (!endpoint) return;
    const context = sourceEvent.target?.closest?.("[data-endpoint]")?.dataset || {};
    const payload = {
      event_id: crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      event_type: eventType,
      occurred_at: new Date().toISOString(),
      session_id: sessionId(),
      query: String(detail.query || "").slice(0, 250),
      result_count: detail.resultCount == null ? null : Math.max(0, Number(detail.resultCount) || 0),
      product_id: detail.productId ? String(detail.productId).slice(0, 40) : null,
      celebrity_handle: detail.celebrity ? String(detail.celebrity).slice(0, 80) : null,
      locale: String(context.locale || document.documentElement.lang || "es").slice(0, 10),
      language: String(context.language || document.documentElement.lang || "es").slice(0, 20),
      country: /^[A-Za-z]{2}$/.test(String(context.country || "")) ? String(context.country).toUpperCase() : null,
      currency: /^[A-Za-z]{3}$/.test(String(context.currency || "")) ? String(context.currency).toUpperCase() : null,
      mode: String(detail.kind || "celebrity").slice(0, 40),
    };
    Object.keys(payload).forEach((key) => payload[key] == null && delete payload[key]);
    document.dispatchEvent(new CustomEvent("ohc:analytics", { detail: payload }));
    fetch(endpoint, {
      method: "POST",
      mode: "cors",
      keepalive: true,
      credentials: "omit",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).catch(() => {});
  };

  document.addEventListener("oh:celebrity-search", (event) => send(event, "celebrity_search", event.detail || {}));
  document.addEventListener("oh:celebrity-click", (event) => {
    const detail = event.detail || {};
    send(event, detail.kind === "product" ? "celebrity_product_click" : "celebrity_click", detail);
  });
})();
